import {Divider} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import BlockAccessPage from '../../../../components/BlockAccess/BlockAccessPage';
import Loader from '../../../../components/Loader/Loader';
import {checkIfHasPermissions} from '../../../../components/Menu/Utils/commonFunctions';
import DownSupplier from '../../../../components/Table/DownSupplier';
import UpstreamSupplier from '../../../../components/Table/UpSupplier';
import Tabs from '../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../constants/permissionsEnum';
import TranslatedText from '../../../../libraries/I18N/TranslatedText';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import country from '../../../../services/modules/JSON/country';
import facilityType from '../../../../services/modules/JSON/facilityType';
import facilityDetailsAPI from '../../../../services/modules/OM/facilityDetails';
import useCompanyStore, {
  accessModule
} from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {shouldBlockModuleAccess} from '../../../../utils/SubscriptionHelper';
import FacilitySelect from '../../../orgManager/Utils/InfraStructureProfile/Utils/FacilitySelect';

const SupplierInfo: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');
  const [facilityId, setFacilityId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isListView, setIsListView] = useState(true);
  const facilityDetails = useCompanyStore.getState().facilityDetails;

  // const firstYear = yearSelect();

  const IPTab = [
    {
      id: 'upSupply_externalStakeholder',
      name: <TranslatedText translationKey="Upstream" />,
      component: shouldBlockModuleAccess(accessModule.externalStakeholders) ? (
        <BlockAccessPage />
      ) : (
        <UpstreamSupplier
          facilityId={facilityId}
          selectedYear={selectedYear}
          isListView={isListView}
        />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.ConfiguratorUpstream)
    },
    {
      id: 'downSupply_externalStakeholder',
      name: <TranslatedText translationKey="Downstream" />,
      component: shouldBlockModuleAccess(accessModule.externalStakeholders) ? (
        <BlockAccessPage />
      ) : (
        <DownSupplier
          facilityId={facilityId}
          selectedYear={selectedYear}
          isListView={isListView}
        />
      ),
      hidden: !checkIfHasPermissions(PermissionEnum.ConfiguratorDownstream)
    }
  ].filter((item) => !item.hidden);

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
    setSelectedYear(currentYear);
    Promise.all([
      facilityDetailsAPI(APITypeEnum.GET_ALL, false),
      facilityType(),
      country()
    ])
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (searchParam.get('selectedYear')) {
      if (
        facilityDetails?.[searchParam.get('selectedYear') ?? '']?.some(
          (item: any) => {
            return item._id === searchParam.get('facility');
          }
        )
      ) {
        searchParam.set('facility', searchParam.get('facility') as string);
        setSearchParams(searchParam);
        setFacilityId(searchParam.get('facility') ?? '');
      } else {
        searchParam.delete('facility');
        setSearchParams(searchParam);
        setFacilityId('');
      }
    }
  }, [facilityDetails]);

  return isLoading ? (
    <Loader />
  ) : (
    selectedYear !== '' && (
      <>
        <div
          style={{
            marginTop: '1.5rem',
            marginBottom: '1rem',
            font: 'normal normal 500 14px/22px Montserrat',
            letterSpacing: '0px',
            color: '#000000',
            opacity: 1
          }}
        >
          Set Filters
        </div>

        <FacilitySelect
          setFacilityId={setFacilityId}
          setSelectedYear={setSelectedYear}
          selectedYear={selectedYear}
          showLeased={false}
          showMap={true}
          setIsListView={setIsListView}
          isConfigurator={'supplier'}
        />

        <Divider />
        <Tabs array={IPTab} />
      </>
    )
  );
};

export default SupplierInfo;
